import { Component, OnInit } from '@angular/core';

import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { IAuthMenu } from '../../models';
import { RequestMenu } from '../../models/messages';
import { AuthorizationService } from '../../services';

@Component({
  selector: 'app-admin-card',
  templateUrl: './admin-card.component.html',
  styleUrls: ['./admin-card.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgTemplateOutlet, NgbDropdownItem]
})

export class AdminCardComponent implements OnInit {

  menuItems: IAuthMenu[] = [];
  hasItems: boolean = false;

  constructor(protected authService: AuthorizationService) {

  }

  ngOnInit() {
    this.refreshMenu();
  }

  refreshMenu(): void {
    let req: RequestMenu = new RequestMenu();
    req.hierarchyCode = "admin";
    const storedMenuData = localStorage.getItem('menuData');
    if (storedMenuData) {
      return;
    }
    this.authService.menuGet$(req).subscribe((data: IAuthMenu[]) => {
      this.menuItems = data;
      this.hasItems = (this.menuItems.length > 0);
    });
  }

  isItemRouteInternal(url: string): boolean {

    if (url.startsWith("http"))
      return false;
    else
      return true;
  }
}
